// @mui material components
import { Icon, Switch, Tooltip, Badge } from '@mui/material';
import IconButton from "@mui/material/IconButton";
import { MDBox } from '../MDBox';
import { MDTypography } from '../MDTypography';
import { IRowAction } from './RowAction';
import { useState } from 'react';

interface IActionsCellProps {
  actions: IRowAction[];
}

export function ActionsCell({
  actions
}: IActionsCellProps) {
  const [switchStates, setSwitchStates] = useState<{ [key: string]: boolean }>(
    actions.reduce((acc, curr) => {
      acc[curr.key] = curr.onOffState ?? false;
      return acc;
    }, {} as { [key: string]: boolean })
  );

  const handleSwitchChange = (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    const newState = { ...switchStates, [key]: event.target.checked };
    setSwitchStates(newState);
    const action = actions.find((a) => a.key === key);
    if (action?.onOffChange) {
      action.onOffChange(event.target.checked);
    }
  };

  return (
    <MDBox display="flex" justifyContent="center" alignItems="center" px={0}>
      {actions.map((action, index) => {
        if (action.onOff) {
          return (
            <Switch
              key={index}
              checked={switchStates[action.key]}
              onChange={handleSwitchChange(action.key)}
            />
          );
        }
        return (
          <IconButton key={index} onClick={() => action.action!(action.key)}>
            <Tooltip title={action.label}>
              <MDTypography variant="caption" color={action.icon!.color} lineHeight={1} sx={{ cursor: action.disabled ? "not-allowed" : "pointer", mx: 0 }}>
                {action.showBadge ? (
                  <Badge badgeContent={action.badgeCount} color="default" sx={{ zIndex: 0 }}>
                    <Icon color="inherit" fontSize="small">{action.icon?.name}</Icon>
                  </Badge>
                ) : (
                  <Icon color={action.disabled ? "disabled" : "inherit"} fontSize="small">{action.icon?.name}</Icon>
                )}
              </MDTypography>
            </Tooltip>
          </IconButton>
        );
      })}
    </MDBox>
  );
}